/* global angular */
( function () {
	'use strict';

	function templateReportPdf ( moment, pdfCommonFactory, attachEvidence, pdfRtfParserObs, attachPd ) {
		var self = this;

		function returnBrackets () {
			return ' [   ] ';
		}

		function returnBlankText () {
			return '';
		}

		function showScoreUtil ( trueFn, blankFn ) {
			function checkScoring () {
				return function () {
					return [ self.showOptions.Scoring ].filter( Boolean ).reduce( trueFn, blankFn )();
				};
			}

			function checkHideScoring () {
				return [ !self.hideScoring ].filter( Boolean ).reduce( trueFn, blankFn )();
			}

			return [ self.showOptions.Scoring !== undefined ].filter( Boolean ).reduce( checkScoring, checkHideScoring )();
		}

		function getStatus ( data ) {
			if ( data.submitDate && self.printFrom !== 'templatePage' ) {
				return 'Completed';
			} else if ( self.printFrom === 'templatePage' ) {
				return '';
			}
			return 'Incomplete';
		}

		function calculateRubricProf ( rubric, score ) {
			var maxProficiency = ( angular.copy( rubric || [] ).pop() || {} ).title || '';

			return [ ( rubric || [] ).reduce( function ( prev, cur ) {
				return prev || score <= cur.maxRange && cur.title;
			}, '' ) || maxProficiency ].filter( Boolean ).reduce( function ( prev, cur ) {
				return ' (' + cur + ')';
			}, '' );
		}

		function createTags ( obsData ) {
			var stackTag = {};

			function mapTagInKey ( item ) {
				var prefix      = [ self.printFrom === 'templatePage' ].filter( Boolean ).reduce( returnBrackets, '' );
				var displayTags = prefix + item;

				return {
					'text'   : displayTags,
					'style'  : 'obsTplHeaderValue',
					'noWrap' : true
				};
			}

			function mapTags ( tag ) {
				var tags = {
					'columns' : []
				};

				var keyArr = Object.keys( JSON.parse( angular.toJson( tag ) ) );

				var key = {
					'width' : '20%',
					'text'  : keyArr[ 0 ],
					'style' : 'obsTplHeaderKey'
				};

				tags.columns.push( key );

				var tagTextArr = tag[ keyArr ].map( mapTagInKey );

				var value = {
					'width' : '80%',
					'text'  : tagTextArr,
					'style' : 'obsTplHeaderValue'
				};

				tags.columns.push( value );

				return tags;
			}

			stackTag.stack = ( obsData.tags || [] ).map( mapTags );

			return stackTag;
		}

		function checkTime ( time ) {
			var formatData = moment( time ).format( 'h:mm A' );
			var returnArr  = [ '', formatData ];

			return returnArr[ Number( Boolean( time ) ) ];
		}

		function checkDate ( date ) {
			var formatData = moment( date ).format( 'MM/DD/YY' );
			var returnArr  = [ '', formatData ];

			return returnArr[ Number( Boolean( date ) ) ];
		}

		function concatName ( objName ) {
			if ( objName ) {
				return objName.lastName + ', ' + objName.firstName;
			}
			return '';
		}

		function getObsType ( obsData ) {
			var obs = angular.copy( obsData );
			var typeText = {};

			function mapObsTypes ( type ) {
				var prefix     = [ self.printFrom === 'templatePage' ].filter( Boolean ).reduce( returnBrackets, '' );
				var withType   = prefix + type;
				var displayArr = [ '', withType ];

				return {
					'style'  : 'obsTplHeaderValue',
					'text'   : displayArr[ Number( Boolean( type ) ) ],
					'noWrap' : true
				};
			}
			typeText = ( obs.type || [ '' ] ).map( mapObsTypes );

			return typeText;
		}

		function createHeaderDetails ( obsData, tags ) {
			var header = {
				'stack' : [
					{
						'columns' : [
							{
								'width' : '20%',
								'text'  : 'Template Name',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '80%',
								'text'  : obsData.template.name,
								'style' : 'obsTplHeaderValue'
							}
						]
					},
					{
						'columns' : [
							{
								'width' : '20%',
								'text'  : 'Observee',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : concatName( obsData.observee ),
								'style' : 'obsTplHeaderValue'
							},
							{
								'width' : '20%',
								'text'  : 'Start Date',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : checkDate( obsData.startDate ),
								'style' : 'obsTplHeaderValue'
							}
						]
					},
					{
						'columns' : [
							{
								'width' : '20%',
								'text'  : 'Observer',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : concatName( obsData.observer ),
								'style' : 'obsTplHeaderValue'
							},
							{
								'width' : '20%',
								'text'  : 'Start Time',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : checkTime( obsData.startDate ),
								'style' : 'obsTplHeaderValue'
							}
						]
					},
					{
						'columns' : [
							{
								'width' : '20%',
								'text'  : 'Type',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : getObsType( obsData )
							},
							{
								'width' : '20%',
								'text'  : 'End Date',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : checkDate( obsData.endDate ),
								'style' : 'obsTplHeaderValue'
							}
						]
					},
					{
						'columns' : [
							{
								'width' : '20%',
								'text'  : 'Status',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : getStatus( obsData ),
								'style' : 'obsTplHeaderValue'
							},
							{
								'width' : '20%',
								'text'  : 'End Time',
								'style' : 'obsTplHeaderKey'
							},
							{
								'width' : '30%',
								'text'  : checkTime( obsData.endDate ),
								'style' : 'obsTplHeaderValue'
							}
						]
					},
					createTags( obsData, tags )
				]
			};

			return header;
		}

		function buildLabel ( indicator ) {
			var label = {
				'stack'  : pdfRtfParserObs.parse( indicator.questionText ),
				'style'  : 'questionText',
				'margin' : [ 10, 12, 10, 5 ]
			};

			return label;
		}

		function attachScore ( text, scoreValue ) {
			function returnScoreText () {
				return function () {
					var scoreText = '   <em>(' + scoreValue + 'pts)</em>  ';

					return scoreValue && scoreText || '';
				};
			}

			function reverser ( str ) {
				return str.split( '' ).reverse().join( '' );
			}

			function splitOnce ( s, token ) {
				var i = s.indexOf( token );

				return [ s.slice( 0, i ), s.slice( i + 1 ) ];
			}

			var revTx = reverser( text );
			var score = reverser( [ self.showOptions.Scoring || ( !self.hideScoring && self.printFrom ) ].filter( Boolean ).reduce( returnScoreText, returnBlankText )() );
			var token = splitOnce( revTx, '<' );
			var isOUL = revTx[ 1 ] === 'l';

			return reverser( [
				token[ 0 ] + '<',
				!isOUL && score || '',
				token[ 1 ].replace( '<', '<' + ( isOUL && score || '' ) )
			].join( '' ) );
		}

		function setOptionFormat ( option, styles ) {
			var selected = [ 'unselected.jpg', 'selected.jpg' ];
			var index    = Number( option.selected || 0 );

			var textObj = {
				'stack'  : pdfRtfParserObs.parse( attachScore( option.optionText, option.value ) ),
				'style'  : styles.styleText,
				'margin' : [ styles.margin[ 0 ] + 5, styles.margin[ 1 ], styles.margin[ 2 ], styles.margin[ 3 ] ]
			};

			var imageObj = {
				'image'  : selected[ index ],
				'width'  : 10,
				'margin' : styles.margin
			};

			var wrapper = {
				'columns' : [ imageObj, textObj ]
			};

			return wrapper;
		}

		function checkScore ( item ) {
			var scoreText;
			var proficiency = pdfCommonFactory.stripHTML( calculateRubricProf( item.rubric, item.score ) );

			if ( item.score === undefined || isNaN( Number( item.score ) ) ) {
				scoreText = ' Score : N/A';
			} else {
				scoreText = ' Score : ' + ( item.notApplicable && 'N/A' || Number( item.score ).toFixed( 2 ) + proficiency );
			}

			function returnScoreText () {
				return function () {
					return scoreText;
				};
			}

			return showScoreUtil( returnScoreText, returnBlankText );
		}

		function buildMultipleChoice ( indicator ) {
			var multipleChoiceFormat = [
				{
					'stack' : pdfRtfParserObs.parse( indicator.questionText ),
					'style' : 'questionText'
				}, {
					'columns' : [
						{
							'text'  : 'Answer',
							'style' : 'answerHeaderText'
						}, {
							'text'  : checkScore( indicator ),
							'style' : 'answerHeaderScore'
						}
					]
				}
			];

			function mapSubOptions ( subOption ) {
				var style = {
					'styleText' : 'answerSubOptions',
					'margin'    : [ 40, 0, 3, 0 ]
				};

				multipleChoiceFormat.push( setOptionFormat( subOption, style ) );
			}

			function mapOptions ( option ) {
				var style = {
					'styleText' : 'answerText',
					'margin'    : [ 25, 0, 3, 0 ]
				};

				multipleChoiceFormat.push( setOptionFormat( option, style ) );

				if ( ( option.selected && option.subOptions ) || ( self.printFrom === 'templatePage' ) ) {
					( option.subOptions || [] ).map( mapSubOptions );
				}
			}

			( indicator.answerOptions || [] ).map( mapOptions );
			return multipleChoiceFormat;
		}

		function checkIfWrapped ( rtfText ) {
			var regexHtml   = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
			var isRtfWraped = regexHtml.test( rtfText );

			if ( !isRtfWraped ) {
				rtfText = '<p>' + rtfText + '</p>';
			}

			return rtfText;
		}

		function buildRubric ( indicator ) {
			var wrapper = {
				'stack' : [
					{
						'stack' : pdfRtfParserObs.parse( indicator.questionText ),
						'style' : 'questionText'
					}, {
						'columns' : [
							{
								'text'  : 'Answer',
								'style' : 'answerHeaderText'
							}, {
								'text'  : checkScore( indicator ),
								'style' : 'answerHeaderScore'
							}
						]
					}
				]
			};

			var rubricTable = {
				'margin' : [ 25, 0, 0, 15 ],
				'table'  : {
					'widths' : [ '100%' ],
					'body'   : [ [] ]
				},
				'layout' : {
					'paddingLeft' : function () {
						return 6;
					},

					'paddingRight' : function () {
						return 6;
					},

					'paddingTop' : function () {
						return 3;
					},

					'paddingBottom' : function () {
						return 3;
					}
				}
			};

			( indicator.answerOptions || [] ).map( function ( options ) {
				if ( !rubricTable.table.body[ 0 ][ 0 ] ) {
					rubricTable.table.body = [];
				}

				function returnRubricScore () {
					return function () {
						var postfix = [ 'pt', 'pts' ];

						return '<p><em>(' + ( options.value || 0 ) + postfix[ Number( options.value > 1 ) ] + ')</em></p>';
					};
				}

				var score = [ self.showOptions.Scoring || ( !self.hideScoring && self.printFrom ) ].filter( Boolean ).reduce( returnRubricScore, returnBlankText )();

				var rubricTitle = {
					'stack' : pdfRtfParserObs.parse( checkIfWrapped( options.optionText ) + score ),
					'style' : 'rubricTitle'
				};

				var rubricDesc  = {
					'stack' : pdfRtfParserObs.parse( options.description ),
					'style' : 'rubricDescription'
				};

				if ( options.selected ) {
					rubricTitle.bold = true;
					rubricDesc.bold  = true;
				}

				rubricTable.table.body.push( [ rubricTitle ] );
				var key = 'Rubric proficiency descriptions';

				if ( ( self.showOptions[ key ] || self.printFrom === 'templatePage' ) && options.description ) {
					rubricTable.table.body.push( [ rubricDesc ] );
				}
			} );

			wrapper.stack.push( rubricTable );

			return wrapper;
		}

		function addAnswerSpaces ( indicator ) {
			if ( self.printFrom === 'templatePage' ) {
				return '\n\n\n\n';
			}

			return ( indicator.answerText || '' );
		}

		function buildOpenEnded ( indicator ) {
			var openEndedFormat = [
				{
					'stack' : pdfRtfParserObs.parse( indicator.questionText ),
					'style' : 'questionText'
				}, {
					'columns' : [
						{
							'text'  : 'Answer',
							'style' : 'answerHeaderText'
						}, {
							'text'  : checkScore( indicator ),
							'style' : 'answerHeaderScore'
						}
					]
				}, {
					'text'  : addAnswerSpaces( indicator ),
					'style' : 'answerText'
				}
			];

			return openEndedFormat;
		}

		var indicatorTypeBuilder = {
			'1' : buildOpenEnded,
			'2' : buildMultipleChoice,
			'3' : buildMultipleChoice,
			'4' : buildRubric,
			'5' : buildLabel
		};

		function mapIndicator ( indicator ) {
			return {
				'pdf'  : ( indicatorTypeBuilder[ indicator.type ] || angular.noop )( indicator ) || {},
				'data' : indicator
			};
		}

		function buildSignatureSection ( signObj ) {
			return Object.keys( signObj ).map( function ( key ) {
				return {
					'margin'  : [ 0, 20, 0, 0 ],
					'columns' : [ {
						'stack' : [ {
							'text'      : signObj[ key ].sign || ' ',
							'alignment' : 'center'
						}, {
							'text'   : '__________________________________________',
							'margin' : [ 0, -17, 0, 0 ]
						}, {
							'text'  : key + ' : ' + ( signObj[ key ].name || '' ),
							'style' : 'signatureLabel'
						} ]
					}, {
						'stack' : [ {
							'text'      : signObj[ key ].date && moment( signObj[ key ].date ).format( 'MM/DD/YYYY h:mm a' ) || ' ',
							'alignment' : 'center'
						}, {
							'text'   : '__________________________________________',
							'margin' : [ 0, -17, 0, 0 ]
						}, {
							'text'  : 'Date',
							'style' : 'signatureLabel'
						} ]
					} ]
				};
			} );
		}

		function generateSignaturePage ( data ) {
			var usersSigArr = [ 'observer', 'observee' ];
			var sigFormat   = [ {
				'text'    : 'Signature : ',
				'italics' : true
			} ];

			function sortObj ( arrObj ) {
				return [ arrObj.sort( function ( a, b ) {
					return parseInt( a, 10 ) > parseInt( b, 10 ) && 1 || -1;
				} ).pop() ].filter( function ( item ) {
					return ( item || {} ).isValid;
				} ).reduce( function ( p, c ) {
					return c;
				}, {} );
			}

			var signObj = usersSigArr.reduce( function ( prev, cur ) {
				var digitalSignatureObj = ( data.digitalSignature || {} )[ cur ] || [];
				var sorted              = angular.copy( sortObj( digitalSignatureObj ) );

				prev[ cur ] = {
					'name' : [ ( data[ cur ] || {} ).firstName, ( data[ cur ] || {} ).lastName ].join( ' ' ),
					'sign' : sorted.sign || '',
					'date' : sorted.date || ''
				};

				return prev;
			}, {} );

			sigFormat.push( buildSignatureSection( signObj ) );

			var sigObj = {
				'stack'  : sigFormat,
				'id'     : 'signature',
				'margin' : [ 0, 20, 0, 0 ]
			};

			return sigObj;
		}

		function generateTotalScore ( observation ) {
			var proficiency = calculateRubricProf( observation.template.rubric, observation.score );

			function returnTotalScore () {
				return function () {
					return 'Total Score : ' + String( Number( ( observation.score || 0 ).toFixed( 2 ) ) || 'N/A' ) + ( observation.score && pdfCommonFactory.stripHTML( proficiency ) || '' );
				};
			}

			var totalScoreText = showScoreUtil( returnTotalScore, returnBlankText );

			return {
				'stack' : [
					{
						'text'  : totalScoreText,
						'style' : 'ObsScore'
					}
				]
			};
		}

		function mapObservations ( observation, index ) {
			self.hideScoring = observation.template.hideScoring;

			function extractMasterPrescribedResources ( prev, cur ) {
				prev[ cur.id ] = cur;
				return prev;
			}

			var masterEvidences = ( observation.masterEvidences || [] ).reduce( extractMasterPrescribedResources, {} );

			var masterPdList = ( observation.masterPrescribedResources || [] ).reduce( extractMasterPrescribedResources, {} );
			var templateBody = {
				'stack'     : [],
				'pageBreak' : index && 'before'
			};
			var key     = 'Evidence';
			var obsBody = {
				'stack' : []
			};

			function createPageSummary ( obsData ) {
				var totalScoreText = generateTotalScore( obsData );
				var sectionScores  = obsData.template.groups.map( function ( group ) {
					return {
						'text' : [ {
							'text'  : group.name,
							'style' : 'groupScore'
						},  {
							'text'  : checkScore( group ),
							'style' : 'groupScore'
						} ]
					};
				} );

				var returnArr      = [ [], [ sectionScores, totalScoreText ] ];
				var conditionIndex = Number( Boolean( self.showOptions.Scoring || !obsData.template.hideScoring ) );

				return {
					'margin' : [ 0, 15, 0, 0 ],
					'stack'  : returnArr[ conditionIndex ]
				};
			}

			function generateFeedBackConvo ( obs ) {
				var tableObj = {
					'fontSize' : 9,
					'table'    : {
						'widths' : [ '25%', '20%', '*' ],
						'body'   : [
							[ {
								'text'  : 'Date and Time',
								'style' : 'feedbackTableHeader'
							}, {
								'text'  : 'Participant',
								'style' : 'feedbackTableHeader'
							}, {
								'text'  : 'Conversation',
								'style' : 'feedbackTableHeader'
							} ]
						]
					}
				};

				( obs.feedback || [] ).forEach( function ( item ) {
					var rowData = [
						moment( item.updatedAt ).format( 'MM/DD/YYYY h:mm:ss a' ),
						item.creatorName,
						pdfRtfParserObs.parse( item.text )
					];

					tableObj.table.body.push( rowData );
				} );

				var feedBackSection = [ {
					'text'  : 'Observation Feedback & Conversation',
					'style' : 'feedbackHeader'
				},
				tableObj ];

				var returnArr = [ [], feedBackSection ];
				var stackObj  = { 'stack' : [] };
				var condition = Number( Boolean( ( obs.feedback || [] ).length ) );

				stackObj = returnArr[ condition ];
				return stackObj;
			}

			function mapGroup ( group ) {
				var groups = {
					'stack' : []
				};

				var grpObj = {
					'columns' : [
						{
							'width' : '70%',
							'text'  : group.name,
							'style' : 'groupTitle'
						}, {
							'width' : '30%',
							'text'  : checkScore( group ),
							'style' : 'groupScore'
						}
					]
				};

				var obj = {
					'columns' : [ grpObj ],
					'style'   : 'groupContainer'
				};

				groups.stack.push( obj );

				var indicators = ( group.indicators || [] )
					.map( mapIndicator )
					.reduce( function ( prev, next ) {
						prev.push( next.pdf );
						if ( ( ( next.data || {} ).evidences || [] ).length && self.showOptions[ key ] ) {
							prev.push( attachEvidence( next.data, masterEvidences ) );
						}

						if ( ( ( next.data || {} ).prescribedResources || [] ).length ) {
							prev.push( attachPd( next.data, masterPdList, 1 ) );
						}
						return prev;
					}, [] );

				if ( ( group.evidences || [] ).length && self.showOptions[ key ] ) {
					indicators.push( attachEvidence( group, masterEvidences, false, true ) );
				}

				if ( ( group.prescribedResources || [] ).length ) {
					indicators.push( attachPd( group, masterPdList, 0 ) );
				}

				var indicatorBody = [].concat.apply( [], indicators );

				groups.stack.push.apply( groups.stack, indicatorBody );

				return groups;
			}

			templateBody.stack.push( createHeaderDetails( observation ) );
			templateBody.stack.push( createPageSummary( observation ) );
			templateBody.stack.push( generateSignaturePage( observation ) );

			obsBody.stack     = observation.template.groups.map( mapGroup );
			obsBody.pageBreak = 'before';

			templateBody.stack.push( obsBody );
			templateBody.stack.push( generateTotalScore( observation ) );

			if ( ( observation.evidences || [] ).length && self.showOptions[ key ] ) {
				templateBody.stack.push( attachEvidence( observation, masterEvidences, true ) );
			}

			if ( ( observation.prescribedResources || [] ).length ) {
				templateBody.stack.push( attachPd( observation, masterPdList, 0 ) );
			}

			templateBody.stack.push( generateFeedBackConvo( observation ) );

			return templateBody;
		}

		function buildTemplateReport ( obsData ) {
			var observations = {
				'stack' : []
			};

			observations.stack = obsData.map( mapObservations );
			return observations;
		}

		function buildReport ( obsData, filters, showOptions, printFrom ) {
			self.showOptions = showOptions || {};
			self.printFrom   = printFrom;

			var sections = {
				'pageBreak' : 'before',
				'stack'     : [
					pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2 ),
					buildTemplateReport( obsData )
				]
			};

			return sections;
		}

		function mapInvitees ( invitee ) {
			return invitee.name;
		}

		function flattenInvitees ( invitees ) {
			return ( invitees || [] ).map( mapInvitees ).join( ', ' );
		}

		function generateFrontPageDetails ( filters ) {
			var section = {
				'stack' : [
					{
						'columns' : [
							{
								'text'      : 'Search Criteria',
								'width'     : '25%',
								'alignment' : 'right'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Template Name',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.templateName,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}

						]
					}, {
						'columns' : [
							{
								'text'  : 'Observee(s)',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : flattenInvitees( filters.invitees ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}

						]
					}, {
						'columns' : [
							{
								'text'  : 'Type(s)',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : ( filters.types || [] ).join( ', ' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range From',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.startDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range To',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.endDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Location(s)',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : ( filters.locations || [] ).join( ', ' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Report Generated On',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( new Date() ).format( 'MM/DD/YY h:mm A' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Number Of Observations',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : String( filters.numberOfResults ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}

				]
			};

			return section;
		}

		function generateFrontPage ( filters ) {
			var sections = {
				'stack' : [ pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2 ),
					generateFrontPageDetails( filters ) ]
			};

			return sections;
		}

		return {
			'buildReport'       : buildReport,
			'generateFrontPage' : generateFrontPage
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'templateReportPdf', templateReportPdf );

	templateReportPdf.$inject = [ 'moment', 'pdfCommonFactory', 'pdfTemplateEvidence', 'pdfRtfParserObs', 'pdfTemplateAttachPd' ];
} )();
